import { Loader2 } from 'lucide-react';
import { RestrictionForm, RestrictionsList, ShiftRequiredGuard } from '../components';
import { useRestrictions } from '../hooks';

export const RestrictionsPage = () => (
  <ShiftRequiredGuard>
    <RestrictionsContent />
  </ShiftRequiredGuard>
);

const RestrictionsContent = () => {
  const { restrictions, loading, actionLoading, error, createRestriction, deleteRestriction } = useRestrictions();

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold text-slate-800">Lista de Restricciones</h2>
        <p className="text-slate-500 text-sm">Personas y vehiculos con acceso restringido</p>
      </div>

      {error && (
        <div className="p-4 bg-red-50 text-red-700 rounded-xl">
          {error}
        </div>
      )}

      <div className="grid gap-6 lg:grid-cols-2">
        {/* Form */}
        <RestrictionForm
          onSubmit={createRestriction}
          loading={actionLoading}
        />

        {/* List */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-slate-800 mb-4">
            Restricciones Activas ({restrictions.filter(r => r.active).length})
          </h3>

          {loading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="w-6 h-6 animate-spin text-primary-500" />
            </div>
          ) : (
            <RestrictionsList
              restrictions={restrictions.filter(r => r.active)}
              onDelete={deleteRestriction}
              deleting={actionLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};
